"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var guest_chat_1 = require("../../messages/guest-chat");

var base_1 = __importDefault(require("../base"));

var methods_factory_1 = require("../methods-factory");

var ControllerClient =
/*#__PURE__*/
function (_base_1$default) {
  _inherits(ControllerClient, _base_1$default);

  function ControllerClient(options) {
    var _this;

    _classCallCheck(this, ControllerClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ControllerClient).call(this, options));
    _this.acceptGuestChatAnswer = methods_factory_1.AcceptMessageFactory(guest_chat_1.GuestChatAnswer, 1);
    _this.acceptGuestChatComplete = methods_factory_1.AcceptMessageFactory(guest_chat_1.GuestChatComplete, 1);
    _this.acceptGuestChatDecline = methods_factory_1.AcceptMessageFactory(guest_chat_1.GuestChatDecline, 1);
    _this.acceptProxyGuestChatRequest = methods_factory_1.AcceptMessageFactory(guest_chat_1.ProxyGuestChatRequest, 1);
    _this.unacceptGuestChatAnswer = methods_factory_1.UnacceptMessageFactory(guest_chat_1.GuestChatAnswer);
    _this.unacceptGuestChatComplete = methods_factory_1.UnacceptMessageFactory(guest_chat_1.GuestChatComplete);
    _this.unacceptGuestChatDecline = methods_factory_1.UnacceptMessageFactory(guest_chat_1.GuestChatDecline);
    _this.unacceptProxyGuestChatRequest = methods_factory_1.UnacceptMessageFactory(guest_chat_1.ProxyGuestChatRequest);
    _this.sendGuestChatHandled = methods_factory_1.SendMessageFactory();
    _this.sendGuestChatRequest = methods_factory_1.SendMessageFactory();
    _this.sendNoStaffOnline = methods_factory_1.SendMessageFactory();
    _this.sendProxyGuestChatRequestTimeout = methods_factory_1.SendMessageFactory();
    _this.sendProxyGuestChatDecline = methods_factory_1.SendMessageFactory();
    _this.sendGuestChatRequestTimeout = methods_factory_1.SendMessageFactory();
    return _this;
  }

  return ControllerClient;
}(base_1.default);

exports.ControllerClient = ControllerClient;
exports.default = ControllerClient;